///include /assets/js/app/p/checkout.js
///include /assets/js/app/p/s-basket-service.js
///include /assets/js/app/s/basket.js

"use strict"

class SCheckoutBasket extends SBasket {
    /**
     * @param {generalPaymentType} abstract_type
     * @returns {boolean}
     */
    static abstractPaymentTypeRequiresSelection(abstract_type) {
        const real_types = SBasketService.realTypesFor(abstract_type)
        return real_types.every(
            type => this.paymentTypeRequiresSelection(type)
        )
    }

    /**
     * @param {SPaymentItem["type"]} real_type
     * @returns {?boolean}
     */
    static paymentTypeRequiresSelection(real_type) {
        const drivers = Checkout.driversForPaymentType(real_type)
        return drivers && drivers.every(
            d => d.requiresImmediateSelection
        )
    }

    constructor() {
        super()

        /**
         * This is true except for when freezing, min ~300ms
         */
        this.freezeWaitComplete = true
        this.ref = sessionStorage.basketFreezeRef || null
        this.refreezing = false
        this.selectedPayment = new SBasketPaymentSelection()
    }

    /**
     * @type {boolean | null}
     */
    get canSaveProforma() {
        if(
            this.itemsFlat &&
            this.itemsFlat.some(
                i => i.paymentSelections && i.paymentSelections.some(
                    //@ts-ignore
                    ps => ps && !!ps.upstreamPaymentRef
                )
            )
        ) {
            return false
        }
        return Checkout.drivers && Checkout.drivers.some(
            d => !d.requiresSelection
        )
    }

    /**
     * @type {?boolean}
     */
    get eligibleForCheckout() {
        return this.itemsFlat && !this.itemsFlat.some(
            //@ts-ignore
            i => i.paymentSelections && i.paymentSelections.some(ps => !!ps.upstreamRepeatPaymentRef)
        )
    }

    get isFrozen() {
        return !!this.ref
    }

    get networkMethodInfo() {
        return {
            path: `/n/basket/${this.ref || "own"}`,
        }
    }

    get networkPropertyHandlers() {
        return {
            content: () => $.ajax(this.path),
            discountCodes: () => $.ajax(`/n/discountCodes`),
            items: () => this.preloadSingle("content").then(
                content => {
                    /** @type {{[ref: string]: SBasketItem}} */
                    const items = {}
                    for(let [ref, item] of Object.entries(content)) {
                        items[ref] = new SBasketItem(item, ref)
                    }
                    const items_flat = []
                    for(const item of Object.values(items)) {
                        if(item.itemsFlat) {
                            items_flat.push(item, ...item.itemsFlat)
                        }
                    }
                    $(document).trigger(
                        "Basket:updated",
                        [
                            undefined,
                            items_flat,
                        ]
                    )
                    return Promise.resolve(items)
                }
            )
        }
    }

    get path() {
        return `/n/basket/${this.ref || "own"}`
    }
    /**
     * @type {boolean | null | undefined} true if the final checkout button
     * should be shown, modulo any payment selections
     */
    get readyForPurchase() {
        return(
            this.freezeWaitComplete &&
            this.ref &&
            this.items &&
            !!Object.keys(this.items).length &&
            !this.refreezing
        )
    }
    get ref() {
        return this._ref
    }
    set ref(v) {
        this._ref = v
        if(v) {
            sessionStorage.basketFreezeRef = v
        } // It's ok to keep a non-existent ref
    }

    prepareFreezeWait() {
        this.freezeWaitComplete = false
    }

    /**
     * @param {string} key
     */
    async remove(key) {
        if(this.ref) {
            this.refreezing = true
            await this.thaw()
        }
        await $.ajax({
            method: "delete",
            url: `${this.path}/${key}`
        })
        if(this.refreezing) {
            await this.freeze()
            this.refreezing = false
        }
        this.reload(["content", "items"])
    }
    /**
     * @param {AnyBasketItemInst} item
     * @return {Promise<boolean>}
     */
    async removeItem(item) {
        if(item instanceof SBasketItem) {
            if(this.ref) {
                this.refreezing = true
                await this.thaw()
                await $.ajax({
                    method: "delete",
                    url: `${this.path}/${item.ref}`
                })
                await this.freeze()
                this.refreezing = false
            } else {
                await $.ajax({
                    method: "delete",
                    url: `${this.path}/${item.ref}`
                })
            }
            this.reload(["content", "items"])
            return true
        } else {
            return false
        }
    }
    /**
     * Resets all basket state
     */
    reset() {
        this.ref = null
        super.reset()
    }
    startFreezeWait() {
        setTimeout(
            () => this.freezeWaitComplete = true,
            300
        )
    }
}
/** @type {JSONRPC.Stack.Basket.$ns.basket.ref.$freeze} */
SCheckoutBasket.prototype.freeze = NPSUtil.j(
    SCheckoutBasket,
    "freeze",
    {
        /** @param {POST.Stack.Basket.$ns.basket.ref.$freeze.output["result"]} result */
        success(result) {
            if(result) {
                this.content = result.content.items
                this.ref = result.ref
                this.reload(["items"])
                this.startFreezeWait()
            }
        },
        error() {
            this.startFreezeWait()
        },
        beforeCall() {
            console.log("Freezing")
            this.content = null
            this.prepareFreezeWait()
        }
    }
)

/** @type {JSONRPC.Stack.Basket.$ns.basket.ref.$thaw} */
SCheckoutBasket.prototype.thaw = NPSUtil.j(
    SCheckoutBasket,
    "thaw",
    {
        beforeCall() {
            console.log("Thawing")
        },
        /** @param {POST.Stack.Basket.$ns.basket.ref.$thaw.output["result"]} result */
        success(result) {
            if(result) {
                this.content = result.content.items
                this.ref = result.ref
                this.reload(["items"])
            }
        },
    }
)

SCheckoutBasket.prototype.thawBeacon = function() {
    console.log("Thawing")
    return this.jsonRPCBeacon(this.path, "thaw")
}

//@ts-ignore
AnyBasket.register(SCheckoutBasket)
AnyBasket._inst = null
